import React, { useEffect, useState } from "react";
import "./AddModal.css";
import { Paginations, SpinnerLoading } from "../../../../components";
import { axiosGet } from "../../../../utils/apis/api";
import { Modal } from "react-bootstrap";
import servicesIcon from "../../../../assets/images/packages/svg/services.svg";
import FluentInfo from "../../../../assets/images/packages/svg/fluent_info.svg";
import { useTranslation } from "../../../../contexts/TranslationContext";
import dayjs from "dayjs";
import { Tooltip } from "react-tooltip";
import Cookies from "js-cookie";

const AddServiceModal = ({
  url,
  openService,
  setOpenService,
  onContinue,
  handleAdd,
  selectedDestination,
  selectedDates,
}) => {
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const Lang = Cookies.get("preferred_language") || "en";
  const resultsPerPage = 4;
  const { t } = useTranslation();
  const [clicked, setClicked] = React.useState(false);

  const handleContinue = () => {
    if (selectedServices.length === 0) return;
    onContinue(selectedServices);
    // const items = selectedServices.map((service) => ({
    //     package_component_type: "Service",
    //     package_component_id: service,
    //     destination_row_id: selectedDestination.name,
    //     date_from: selectedDates?.startDate
    //       ? dayjs(selectedDates.startDate).format("YYYY-MM-DD HH:mm:ss")
    //       : null,
    //     date_to: selectedDates?.endDate
    //       ? dayjs(selectedDates.endDate).format("YYYY-MM-DD HH:mm:ss")
    //       : null,
    //     from_destination: selectedDestination.location,
    //     to_destination: null,
    //   }));
    // handleAdd(items);
  };

  const fetchServices = async (pageNumber = 1) => {
    try {
      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.service.service.service?start=${start}&limit=${resultsPerPage}`;

      setLoading(true);
      const response = await axiosGet(apiUrl);
      const result = response.result;
      setCurrentPage(result.pagination.metadata.current_page);
      setTotalPages(result.pagination.metadata.total_pages);
      setServices(result.items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return { data: null, error: error.message };
    }
  };

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchServices(pageNumber);
  };

  useEffect(() => {
    if (openService) {
      fetchServices();
    }
  }, [openService]);

  if (!openService) return null;

  return (
    <Modal
      show={openService}
      onHide={() => {
        setCurrentPage(1);
        setTotalPages(1);
        setSelectedServices([]);
        setOpenService(false);
      }}
      className={`add-hotel-modal modal-service ${
        Lang === "ar" ? "rtl" : "ltr"
      }`}
    >
      <Modal.Body className="">
        <div className="add-hotel-modal-body">
          <div className="add-hotel-logo">
            <img src={servicesIcon} alt="service" />
          </div>
          <div className="add-hotel-title">{t("AddServices")}</div>
          <div className="add-hotel-date">
            {dayjs(selectedDates.startDate).format("MMM D")} -{" "}
            {dayjs(selectedDates.endDate).format("MMM D")} {t("In")}{" "}
            {selectedDestination?.location_name}
          </div>
          <div className="add-hotel-desc">{t("chooseExtraService")}</div>
        </div>

        <div className="services-checkboxes-div">
          {loading ? (
            <div className="loading-container">
              <SpinnerLoading />
            </div>
          ) : (
            services.map((item, index) => {
              return (
                <div className="service-checkbox">
                  <label className="service-checkboc-label">
                    <input
                      key={index}
                      type="checkbox"
                      className="input-service"
                      name="services"
                      value={item.name}
                      checked={selectedServices.includes(item.name)}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedServices((prev) => {
                          if (prev.includes(value)) {
                            return prev.filter((service) => service !== value);
                          } else {
                            return [...prev, value];
                          }
                        });
                      }}
                    />
                    {item.service_name}
                  </label>
                  <img
                    src={FluentInfo}
                    data-tooltip-id={`tooltip-${index}`}
                    data-tooltip-content={item?.details || t("NoDescription")}
                    alt="info"
                    style={{ cursor: "pointer", marginLeft: "8px" }}
                  />

                  <Tooltip
                    id={`tooltip-${index}`}
                    place="top"
                    style={{
                      whiteSpace: "normal",
                      maxWidth: "300px",
                      wordBreak: "break-word",
                      padding: "10px",
                      lineHeight: 1.3,
                      overflowWrap: "break-word",
                    }}
                  />
                </div>
              );
            })
          )}
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center ">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        )}

        <div
          className={`add-modal-submit ${
            clicked ? "active clicked" : "active"
          }`}
          onClick={() => {
            setClicked(true);
            handleContinue();
          }}
        >
          {t("Continue")}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddServiceModal;
